// extracted by mini-css-extract-plugin
module.exports = {"gameItemWrapper":"_7b2c3b1","gameGridImage":"_0cd053b","gameItemText":"_6a6bb30"};